<template>
  <v-card flat>
    <v-card-title class="px-0">
      <span class="text-caption font-weight-bold">Line Items</span>
      
      <v-spacer></v-spacer>

      <template v-if="showEditItems">
        <v-btn color="secondary" small @click="openEditLineItems">
          <v-icon small class="mr-1">edit</v-icon>Edit Items
        </v-btn>      
      </template>
    </v-card-title>

    <v-card-text class="pa-0">
      <v-data-table :headers="headers" :items="getLineItems" disable-sort hide-default-footer class="body--text">
        <template v-slot:item.price="{item}">{{ item.price | formatPrice }}</template>
        <template v-slot:item.total="{item}">{{ item.total | formatPrice }}</template>
        <template v-slot:item.creditAmount="{item}">{{ creditAmount(item.creditAmount) | formatPrice }}</template>
      </v-data-table>
    </v-card-text>

    <EditLineItemsDialog />
  </v-card>
</template>

<script>
  import { mapMutations, mapGetters } from 'vuex';
  
  import EditLineItemsDialog from './EditLineItems/EditLineItemsDialog.vue';

  export default {
    components: { EditLineItemsDialog },

    props: {
      showEditItems: {
        type: Boolean,
        default: true
      }
    },

    data() {
      return {
        headers: [
          { text: 'Description', value: 'description' },
          { text: 'Price', value: 'price' },
          { text: 'Quantity', value: 'quantity' },
          { text: 'Total', value: 'total' },
          { text: 'Credit Amount', value: 'creditAmount'}
        ]
      }
    },

    computed: {
      ...mapGetters('creditnotes', ['getLineItems', 'getCreateProposalOpen']),

      creditAmount() {
        return (val) => this.getCreateProposalOpen ? val : -val;
      }
    },

    methods: {
      ...mapMutations('creditnotes', ['TOGGLE_EDIT_LINE_ITEMS_DIALOG']),

      openEditLineItems() {
        this.TOGGLE_EDIT_LINE_ITEMS_DIALOG(true);
      }
    }
  }
</script>

<style lang="scss" scoped>
</style>